// 렌더 전용 몸 회전 보간(무빙 다듬기 2026-11-03). 게임 facing은 매 틱 atan2로 순간 바뀐다(몹 배회·추격 방향 전환, 보스, 다른 플레이어).
// 게임 판정은 그대로 두고, 그리는 몸만 '최대 각속도 + 지수 감쇠'로 따라가게 해 한 프레임에 몸이 돌아가는 pop을 없앤다.
// 프레임 루프에서 호출되므로 객체를 만들지 않는다.
import { angleDelta } from '../util';

/** 회전 성격(rad/s 상한, 감쇠 세기). 상위 ARPG 몹·보스 기준: 일반 이동 540°/s, 공격 준비 900°/s, 거대 보스 240°/s */
export interface TurnProfile { readonly maxSpeed: number; readonly sharp: number }
export const TURN_WALK: TurnProfile = { maxSpeed: Math.PI * 3, sharp: 14 };
export const TURN_COMBAT: TurnProfile = { maxSpeed: Math.PI * 5, sharp: 26 };
export const TURN_BOSS: TurnProfile = { maxSpeed: Math.PI * 4 / 3, sharp: 9 };
export const TURN_BOSS_COMBAT: TurnProfile = { maxSpeed: Math.PI * 3, sharp: 18 };

/**
 * cur → target으로 dt(초) 동안 돈 새 각(rad, 감기지 않은 값). dt<=0(히트스톱)이면 그대로.
 * 감쇠로 부드럽게 붙고, 큰 각(배회 반 바퀴)은 maxSpeed로 끊어 '휙' 돌지 않는다.
 */
export function turnToward(cur: number, target: number, dt: number, p: TurnProfile): number {
  if (!(dt > 0)) return cur;
  const d = angleDelta(cur, target);
  let step = d * (1 - Math.exp(-p.sharp * dt));
  const cap = p.maxSpeed * dt;
  if (step > cap) step = cap; else if (step < -cap) step = -cap;
  // 아주 작은 남은 각은 붙여 끝없이 미세하게 도는 것을 막는다(0.05°)
  if (Math.abs(d - step) < 1e-3) return cur + d;
  return cur + step;
}
